import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import { saveAccessTokenFromQuery } from '@/utils/auth'

const routes: RouteRecordRaw[] = [
  {
    path: '/welcome',
    name: 'Welcome',
    component: () => import('@/views/onboarding/Welcome.vue'),
  },
  {
    path: '/consult-review/:recordId?',
    name: 'ConsultationReview',
    component: () => import('@/views/consultation/ConsultationReview.vue'),
  },
  {
    path: '/consult-strategy',
    name: 'ConsultationStrategy',
    component: () => import('@/views/consultation/ConsultationStrategy.vue'),
  },
  {
    // 分享落地页：复用录音详情页（展示态），与 APP 内页面保持一致
    path: '/share/:shareCode',
    name: 'Share',
    component: () => import('@/views/recording/RecordingDetail.vue'),
  },
  {
    path: '/recording-detail/:recordingId?',
    name: 'RecordingDetail',
    component: () => import('@/views/recording/RecordingDetail.vue'),
  },
  {
    path: '/customer-detail/:customerId?',
    name: 'CustomerDetail',
    component: () => import('@/views/customer/CustomerDetail.vue'),
  },
  {
    path: '/customer-ownership/:recordingId?',
    name: 'CustomerOwnership',
    component: () => import('@/views/customer/CustomerOwnership.vue'),
  },
  {
    path: '/customer-ownership-search',
    name: 'CustomerOwnershipSearch',
    component: () => import('@/views/customer/CustomerOwnership.vue'),
  },
  {
    path: '/customer-search',
    name: 'CustomerSearch',
    component: () => import('@/views/customer/CustomerSearch.vue'),
  },
  {
    path: '/duration-usage',
    name: 'DurationUsage',
    component: () => import('@/views/duration/DurationUsage.vue'),
  },
  {
    path: '/duration-store',
    name: 'DurationStore',
    component: () => import('@/views/duration/DurationStore.vue'),
  },
  {
    path: '/duration-purchase-history',
    name: 'DurationPurchaseHistory',
    component: () => import('@/views/duration/DurationPurchaseHistory.vue'),
  },
  {
    path: '/duration-purchase-history/:purchaseId',
    name: 'DurationPurchaseHistoryDetail',
    component: () => import('@/views/duration/DurationPurchaseHistoryDetail.vue'),
  },
  {
    path: '/contact-service',
    name: 'ContactService',
    component: () => import('@/views/service/ContactService.vue'),
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: () => import('@/views/legal/PrivacyPolicy.vue'),
  },
  {
    path: '/user-agreement',
    name: 'UserAgreement',
    component: () => import('@/views/legal/UserAgreement.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/system/NotFound.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to) => {
  const token = to.query.token as string | undefined
  saveAccessTokenFromQuery(token)
})

export default router
